import { Annual } from '@/components/resort/HistoricalSnowfall/Annual';
import { ISnowfallItem } from '@/api/resort/types';
import { Monthly } from '@/components/resort/HistoricalSnowfall/Monthly';

// Historical snowfall section on the Resort Snow Planner page.
// Renders the Monthly table first, then the Annual table below,
// matching the redesign sandbox (the prior tab toggle is gone — the
// design system reference shows both tables stacked).

export const HistoricalSnowfall = ({
  snowfallInfoMonthly,
  snowfallInfoAnnual,
  resortName,
}: {
  snowfallInfoMonthly: Array<ISnowfallItem>;
  snowfallInfoAnnual: Array<ISnowfallItem>;
  resortName: string;
}) => (
  <div>
    {snowfallInfoMonthly.length > 0 && (
      <Monthly infoMonthly={snowfallInfoMonthly} resortName={resortName} />
    )}
    {snowfallInfoAnnual.length > 0 && (
      <Annual infoAnnual={snowfallInfoAnnual} resortName={resortName} />
    )}
  </div>
);
